import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IVRConversation from './IVRConversation';

class IVRConversationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { conversation, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              IVR Conversation:
              {` ${conversation.id}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <IVRConversation conversation={conversation} />;
              }
              return undefined;
            })()}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

IVRConversationModal.propTypes = {
  conversation: PropTypes.instanceOf(Object).isRequired,
};

export default IVRConversationModal;
